import { OptionsObject, SnackbarMessage } from "notistack";

type EnqueueSnackbar = (
  message: SnackbarMessage,
  options?: OptionsObject
) => void;

let enqueueSnackbarRef: EnqueueSnackbar | null = null;

export const setSnackbarRef = (fn: EnqueueSnackbar) => {
  enqueueSnackbarRef = fn;
};

export const notify = (message: SnackbarMessage, options?: OptionsObject) => {
  enqueueSnackbarRef?.(message, options);
};
